<div class="grid-row grid-gap-1 text-center">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3 text-right">
    <label class="usa-label" for="items_per_page">Show:</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1">
    <select id="items_per_page" [(ngModel)]="itemsPerPage" class="usa-select">
      @for (itemsPerPage of itemsPerPageList; track itemsPerPage) {
        <option [ngValue]="itemsPerPage">{{itemsPerPage}}</option>
      }
    </select>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6  display-flex flex-row">
    <div class="flex-align-self-center">
      <pagination #paginationModule [boundaryLinks]="true" [directionLinks]="false" [totalItems]="totalItems" [maxSize]="5" [itemsPerPage]="itemsPerPage" rotate="true" [ngModel]="currentPage" (ngModelChange)="page($event)" class="m-0" previousText="Previous"
        nextText="Next" firstText="First" lastText="Last">
      </pagination>
    </div>
  </div>
</div>